/**
 * OrbDocTutorialsBeginnerTaskManagerARDocEx1TaskListView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsBeginnerTaskManagerARDocEx1TaskList
 */

import { useOrbDocTutorialsBeginnerTaskManagerARDocEx1TaskListLogic } from '@/hooks/traits/useOrbDocTutorialsBeginnerTaskManagerARDocEx1TaskListLogic';
import type { OrbDocTutorialsBeginnerTaskManagerARDocEx1TaskListConfig } from '@/hooks/traits/useOrbDocTutorialsBeginnerTaskManagerARDocEx1TaskListLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsBeginnerTaskManagerARTask } from '@app/shared';
import { Alert } from '@almadar/ui/components';
import { DataList } from '@almadar/ui/components';
import { Skeleton } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsBeginnerTaskManagerARDocEx1TaskListViewProps {
  config?: Partial<OrbDocTutorialsBeginnerTaskManagerARDocEx1TaskListConfig>;
}

export function OrbDocTutorialsBeginnerTaskManagerARDocEx1TaskListView({ config: propsConfig }: OrbDocTutorialsBeginnerTaskManagerARDocEx1TaskListViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsBeginnerTaskManagerARDocEx1TaskListLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsBeginnerTaskManagerARTask'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsBeginnerTaskManagerAR" trait="OrbDocTutorialsBeginnerTaskManagerARDocEx1TaskList">
      {slotWriter['main'] === 'INIT' ? (<Skeleton variant="list" rows={3} />) : slotWriter['main'] === 'TasksLoaded' ? (<DataList entity={Array.isArray(lastPayload?.data) ? ((lastPayload?.data) as readonly EntityRow[]) : []} fields={Array.isArray([{ name: "title", label: "Task", variant: "h4" }, { name: "done", label: "Done", variant: "badge", labels: {true: "Done" as const, false: "Open" as const} }]) ? ((([{ name: "title", label: "Task", variant: "h4" }, { name: "done", label: "Done", variant: "badge", labels: {true: "Done" as const, false: "Open" as const} }]) as EntityRow[]) as ({ colorMap?: never; format?: 'date' | 'time' | 'datetime' | 'currency' | 'number' | 'boolean' | 'percent'; icon?: string; label?: string; labels?: never; name: string; variant?: 'h3' | 'h4' | 'overline' | 'avatar' | 'body' | 'caption' | 'badge' | 'small' | 'progress' })[]) : []} itemActions={[{ label: "Complete", event: "OrbDocTutorialsBeginnerTaskManagerAR.OrbDocTutorialsBeginnerTaskManagerARDocEx1TaskList.COMPLETE", variant: "ghost" as const, when: ["fn", "row", ["not", ["object/get", "@row", "done", false]]] }, { label: "Delete", event: "OrbDocTutorialsBeginnerTaskManagerAR.OrbDocTutorialsBeginnerTaskManagerARDocEx1TaskList.DELETE", variant: "danger" as const }]} emptyTitle="Nothing to do" emptyDescription="Add a task with the form." emptyIcon="check-circle" />) : slotWriter['main'] === 'TasksFailed' ? (<Alert variant="error" message={(lastPayload?.error == null ? undefined : String(lastPayload?.error))} />) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsBeginnerTaskManagerARDocEx1TaskListView;
